@if (show) {
  <div
    class="fixed inset-0 bg-[var(--color-gray-900)]/30 flex items-center justify-center z-300 px-4"
    (click)="closeModal()"
  >
    <div
      class="relative w-full max-w-[90vw] sm:max-w-[80vw] md:max-w-[70vw] aspect-video rounded-[12px] overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Spinner de carga -->
      @if (isLoading) {
        <div class="absolute inset-0 z-10 flex items-center justify-center bg-black/50">
          <div class="h-12 w-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      }

      <!-- Video iframe -->
      <iframe
        class="w-full h-full"
        [src]="safeVideoUrl"
        frameborder="0"
        allowfullscreen
        allow="autoplay; encrypted-media"
        (load)="handleIframeLoad()"
      ></iframe>
    </div>
  </div>
}
